import { isNavigationDisabled } from './queryStringHelper';

export const shouldHaveNavigation = () => !isNavigationDisabled();
